var render = function render(){var _vm=this,_c=_vm._self._c;return _c('convenia-modal',_vm._g(_vm._b({class:['login-modal', {
    '-no-header': !!_vm.feedback,
    '-bpo': _vm.appType === 'bpo'
  }],attrs:{"is-opened":"","scroll-el":"login-container","no-header":!!_vm.feedback,"title":_vm.title,"title-props":{ center: true, size: 2 }}},'convenia-modal',_vm.$attrs,false),_vm.$listeners),[(_vm.feedback)?_c('login-feedback',_vm._g({},_vm.$listeners)):_c('login-form',_vm._g(_vm._b({attrs:{"content":_vm.content}},'login-form',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }